import React from 'react'
import Head from 'next/head'
import {PageMeta} from '../../types'
import {createUrl} from '../../utils/createUrl'

type CanonicalUrlProps = {
  meta: PageMeta
  slug: string
}

export const canonicalUrlTestId = 'canonical-url'

/**
 * This is the canonical url link that is used in our document head
 */
export const CanonicalUrlLink: React.FC<CanonicalUrlProps> = ({meta, slug}) => {
  const defaultCanonicalUrl = createUrl(slug)

  return (
    <Head>
      <link
        data-testid={canonicalUrlTestId}
        rel="canonical"
        href={meta.canonicalUrl || defaultCanonicalUrl}
      />
    </Head>
  )
}
